import { render, staticRenderFns } from "./RechargeRecordDialog.vue?vue&type=template&id=6864afc1"
import script from "./RechargeRecordDialog.vue?vue&type=script&lang=js"
export * from "./RechargeRecordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports